<template>
  <el-pagination
    v-bind="$attrs"
    :current-page.sync="currentPage"
    :page-size.sync="pageSize"
    :page-sizes="pageSizes"
    :layout="layout"
    :small="small"
    :pager-count="pagerCount"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
  />
</template>

<script>
export default {
  name: 'BasePagination',
  props: {
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 50
    },
    small: {
      type: Boolean,
      default: true
    },
    pageSizes: {
      type: Array,
      default () {
        return [10, 20, 30, 50, 100, 200]
      }
    },
    pagerCount: {
      type: Number,
      default: 7
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    // 缓存分页的key
    cachekey:{
      type: String,
      default: ''
    }
  },
  computed: {
    currentPage: {
      get () {
        return this.page
      },
      set (val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get () {
        return this.limit
      },
      set (val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
    },
    handleCurrentChange (val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
    }
  }
}
</script>
